import {
  useMutation,
  UseMutationResult,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from '@tanstack/react-query';

import { Tag } from '../@types';
import { createTag, CreateTagRequest, getAllUserTags, getPartAllocatedTags } from '../api/tags';
import { PartAllocatedTagsKey, TagsKey } from '../configs/tags';

export const useAddTags = (): UseMutationResult<Tag, Error, CreateTagRequest> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateTagRequest) => {
      const response = await createTag(data);
      return response;
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [TagsKey],
      });
    },
  });
};

export const useGetAllTags = (
  id: number,
  options?: { enabled?: boolean }
): UseQueryResult<Tag[]> => {
  return useQuery({
    queryKey: [TagsKey, id],
    queryFn: () => getAllUserTags(id),
    enabled: options?.enabled ?? true,
  });
};

export const useGetPartAllocatedTags = (): UseQueryResult<Tag[]> => {
  return useQuery({
    queryKey: [PartAllocatedTagsKey],
    queryFn: () => getPartAllocatedTags(),
  });
};
